import styled from 'styled-components';

const SectionNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14vw;
  height: 14vw;
  border-radius: 50%;
  border: 4px solid var(--text);
  text-align: center;
  font-size: 10vw;
`;

export default SectionNumber;
